// src: https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent

const isMobileBrowser = () => !!/Mobi/i.test(window.navigator.userAgent);

export default isMobileBrowser;
